import { useMemo } from "react";
import cx from "ui/cx";
import styles from "./CodeBlock.module.scss";

interface CodeBlockProps extends React.HTMLProps<HTMLPreElement> {
  code: string | object;
  className?: string;
}

/**
 * Adapted from https://jsfiddle.net/KJQ9K/554
 */
function syntaxHighlight(json: string | object): string {
  if (!json) {
    json = {};
  }

  if (typeof json !== "string") {
    json = JSON.stringify(json, undefined, 2);
  }

  json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

  return json.replace(
    /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
    function (match) {
      let cls = "number";

      if (/^"/.test(match)) {
        if (/:$/.test(match)) {
          cls = "key";
        } else {
          cls = "string";
        }
      } else if (/true|false/.test(match)) {
        cls = "boolean";
      } else if (/null/.test(match)) {
        cls = "null";
      }
      return `<span class="${cls}">${match}</span>`;
    },
  );
}

export default function CodeBlock({ code, className, ...props }: CodeBlockProps) {
  const html = useMemo(() => syntaxHighlight(code), [code]);
  return (
    <pre
      className={cx(styles.wrapper, className)}
      // eslint-disable-next-line @typescript-eslint/naming-convention
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  );
}
